import { AbstractControl } from '@angular/forms';

const REGEX = new RegExp(/^((https?:\/\/)?([\w-]+(\.[\w-]+)+|localhost)\.?(:\d+)?((\/)?\S*)?)$/i);
const SECURE_REGEX = new RegExp(/^((https:\/\/)?([\w-]+(\.[\w-]+)+|localhost)\.?(:\d+)?((\/)?\S*)?)$/i);

export function urlValidatorWithBusinessIdAndSalesUrlReplacement(control: AbstractControl): { [key: string]: any } {
  if (!control.value) {
    return null;
  }
  let url = control.value.replace(/{{\s*business_id\s*}}/, 'AG-123');
  url = url.replace(/{{\s*sales_url\s*}}/, 'https://sales.com');
  url = url.replace(/{{\s*business_app_url\s*}}/, 'https://domain.com');
  return REGEX.test(url) ? null : { url: 'invalid' };
}

export function urlValidator(control: AbstractControl): { [key: string]: any } {
  if (!control.value) {
    return null;
  }
  return REGEX.test(control.value) ? null : { url: 'invalid' };
}

export function secureUrlValidator(control: AbstractControl): { [key: string]: any } {
  if (!control.value) {
    return null;
  }
  return SECURE_REGEX.test(control.value) ? null : { secure: 'invalid' };
}
